<!--
   Created by qing on 2020/12/18
   Des: 项目首页
-->
<template>
	<div
		class="mix-form-main-page"
		v-wechat-title="title"
	>
		<div class="section">
			<div
				class="item"
				@click="onClickItem('ALL')"
			>
				<!-- <i class="iconfont icon-cengji"></i> -->
				<img
					class="project-icon"
					src="../../../assets/images/allproject.png"
				>
				<div class="name">
					全部{{$store.getters.mix_form_name}}
				</div>
				<van-icon name="arrow" />
			</div>
			<div
				class="item"
				@click="onClickItem('CREATE_BY_ME')"
			>
				<!-- <i class="iconfont icon-cengji1"></i> -->
				<img
					class="project-icon"
					src="../../../assets/images/mycreateproject.png"
				>
				<div class="name">
					我创建的{{$store.getters.mix_form_name}}
				</div>
				<van-icon name="arrow" />
			</div>
			<div
				class="item"
				@click="onClickItem('SHARE_TO_ME')"
			>
				<!-- <i class="iconfont icon-fenxianggeiwode"></i> -->
				<img
					class="project-icon"
					src="../../../assets/images/sharedproject.png"
				>
				<div class="name">
					共享给我的{{$store.getters.mix_form_name}}
				</div>
				<van-icon name="arrow" />
			</div>
		</div>
		<div class="section">
			<div
				class="item group-item"
				v-for="group in groupList"
				:key="group.groupId"
				@click="onClickGroup(group)"
			>
				<i class="iconfont icon-collection-list-checked"></i>
				<div class="name">
					{{group.groupName}}
				</div>
				<van-icon name="arrow" />
			</div>
		</div>
		<div
			class="section"
			v-if="topList && topList.length"
		>
			<div class="header">
				置顶{{$store.getters.mix_form_name}}
			</div>
			<div
				class="item group-item"
				v-for="item in topList"
				:key="item.mixFormId"
				@click="onClickMixForm(item)"
			>
				<div class="name">
					{{item.mixFormName}}
				</div>
				<div
					v-if="item.archived"
					class="archived-icon"
				>
					<i class="iconfont icon-icon_submit"></i>
				</div>
				<van-icon name="arrow" />
			</div>
		</div>
		<div
			class="footer"
			@click="onClickHelp"
		>
			<!-- <i class="iconfont icon-xinshouzhinan"></i> -->
			<img class="footer-icon" src="../../../assets/images/newbie.png" >
			新手指南
		</div>

		<div
			class="add-button"
			@click="onClickAddMixForm"
		>
			<i class="el-icon-plus"></i>
		</div>

		<add-mix-form-popup
			ref="addMixFormPopup"
			:stackList="stackList"
			:chargeUserConfig="chargeUserConfig"
			:participantConfig="participantConfig"
			:groupList="groupList"
		></add-mix-form-popup>
	</div>
</template>

<script>
	import AddMixFormPopup from "../../component/mix_form/AddMixFormPopup";
	export default {

		beforeRouteLeave(to, form, next) {
			if (to.name !== "homeMixForm") {
				next(true)
				return
			}
			if (this.chargeUserConfig.showContact) {

				this.chargeUserConfig.showContact = false
				next(false)

			} else if (this.participantConfig.showContact) {

				this.participantConfig.showContact = false
				next(false)

			} else if (this.stackList.length) {

				const visibleInfo = this.stackList.pop()
				visibleInfo.visible = false
				next(false)
			} else {
				next(true)
			}
		},

		components: {
			AddMixFormPopup
		},
		data() {
			return {
				title: '',
				stackList: [],
				chargeUserConfig: {
					showContact: false
				},
				participantConfig: {
					showContact: false
				},

				groupList: [],
				topList: [],
				aEle: null
			}
		},
		created() {
			this.aEle = document.createElement('a')

			if (this.$route.params.pageConfigId) {
				this.$store.dispatch('actionSpacePageConfigDetail', {
					spaceId: this.$route.params.spaceId,
					pageConfigId: this.$route.params.pageConfigId
				}).then(res => {
					this.title = res.pageTitle
					this.$store.dispatch('setPageTitle', this.title)
				}).catch(console.error)
			} else {
				this.title = this.$store.getters.mix_form_name
				this.$store.dispatch('setPageTitle', this.title)
			}

			this.fetchGroupList()
			this.$store.dispatch('actionMixFormTopList')
				.then(res => {
					this.topList = res
				}).catch(console.error)

			this.$store.dispatch('actionAppOperationStatistics', {
				operationType: 'PROJECT'
			}).catch(console.error)
		},
		methods: {
			fetchGroupList() {
				this.$store.dispatch('actionMixFormGroupList')
					.then(res => {
						this.groupList.splice(0, this.groupList.length, ...res)
					}).catch(console.error)
			},
			onClickItem(type) {
				this.$router.push({
					name: 'mixFormList',
					query: {
						type
					}
				})
			},
			onClickGroup(group) {
				this.$router.push({
					name: 'mixFormList',
					query: {
						type: group.groupId
					}
				})
			},
			onClickMixForm(item) {
				this.$router.push({
					name: 'mixFormNodeList',
					query: {
						mixFormId: item.mixFormId
					}
				})
			},

			onClickAddMixForm() {
				if (this.$refs.addMixFormPopup) {
					this.$refs.addMixFormPopup.open({})
				}
			},

			onClickHelp() {
				if (window.isLark) {
					if (this.aEle && this.$store.getters.configMap && this.$store.getters.configMap.helpUrlConfig) {
						this.aEle.href = this.$store.getters.configMap.helpUrlConfig['sys_projectHelp'].larkSrc
					}
				} else {
					if (this.aEle && this.$store.getters.configMap && this.$store.getters.configMap.helpUrlConfig) {
						this.aEle.href = this.$store.getters.configMap.helpUrlConfig['sys_projectHelp'].defaultSrc
					}
				}
				this.aEle.target = '_blank'
				this.aEle.click()
			}
		}
	}
</script>

<style lang="less">
	.mix-form-main-page {
		height: 100%;
		background-color: #F6F6F6;
		overflow: auto;
		box-sizing: border-box;
		-webkit-overflow-scrolling: touch;
		position: relative;

		.section {
			margin: 10px 10px 0 10px;
			border-radius: 10px;
			background-color: #fff;

			.header {
				font-size: 13px;
				color: #3a8ee6;
				line-height: 40px;
				height: 40px;
				padding-left: 10px;
				border-bottom: 1px solid #e6e6e6;
			}

			.item {
				height: 60px;
				display: flex;
				align-items: center;
				border-bottom: 1px solid #e6e6e6;
				background-color: transparent;
				padding: 0 10px;

				>.project-icon {
					width: 17px;
					margin-right: 10px;
				}

				.name {
					flex: 1;
					color: #333333;
					font-size: 14px;
					white-space: nowrap;
					text-overflow: ellipsis;
					overflow: hidden;
					word-wrap: break-word;
				}

				.archived-icon {
					margin-right: 10px;

					i {
						font-size: 34px;
						color: #05A971;
					}
				}

				.van-icon {
					width: 24px;
				}
			}

			.group-item {
				>.iconfont {
					color: #3a8ee6;
				}
			}

			> :nth-last-child(1) {
				border-bottom: none;
			}
		}

		.footer {
			font-size: 14px;
			text-align: center;
			height: 50px;
			line-height: 50px;
			
			.footer-icon{
				width: 25px;
				vertical-align: middle;
				margin-top: -2px;
			}
		}

		> :nth-last-child(1) {
			margin-bottom: 10px;
		}

		.add-button {
			position: fixed;
			bottom: 70px;
			right: 20px;
			border-radius: 50%;
			width: 44px;
			height: 44px;
			padding: 0;
			background-color: #4A66FA;
			display: flex;
			justify-content: center;
			align-items: center;

			i {
				font-size: 20px;
				color: #ffffff;
			}
		}
	}
</style>
